import { Signal } from "signals";
import Layers from "slotworks/graphics/layers/layers";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import Logger from "slotworks/utils/logger";

export interface Control {
    setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup): void;

    getName(): string;

    getOnChange(): Signal;

    updateOptions(options: ControlOptions): void;

    setVisible(visible: boolean): void;

    destroy(): void;

    setEnabled(enabled: boolean): void;

    error(): void;
}

export class AbstractControl implements Control {
    public smartUIGroup: HeadlessSmartUIGroup;
    public name: string;
    protected onChange: Signal;
    protected layer: Layers;
    protected options: ControlOptions;

    protected enabled: boolean = true;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        this.name = name;
        this.smartUIGroup = smartUIGroup;
        this.layer = layer;

        this.onChange = new Signal();
        this.onChange.add((options: ControlOptions) => {
            if (options !== null && options === this.options) {
                Logger.warn(`Options should not be mutated (${name})`);
            }
        });
    }

    public getName(): string {
        return this.name;
    }

    public destroy() {
        this.name = "";
        this.smartUIGroup = null;
        this.onChange.removeAll();
    }

    public setVisible(visible: boolean) {
        // nothing by default
    }

    public getOnChange(): Signal {
        return this.onChange;
    }

    public updateOptions(options: ControlOptions) {
        this.options = options;
    }

    public setEnabled(enabled: boolean): void {
        this.onChange.active = enabled;

        this.enabled = enabled;
    }

    public error(message: string = "has errored"): void {
        throw new Error("Error: control " + (this as any).constructor.name + ", " + message);
    }
}
